module.exports = __webpack_public_path__ + "static/img/zhinan3.17d2230.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhinan3.png
// module id = lXHd
// module chunks = 21